
export const FETCH_ALL_RETAILER_ATTRIBUTES_REQUEST = "FETCH_ALL_RETAILER_ATTRIBUTES_REQUEST";
export const FETCH_ALL_RETAILER_ATTRIBUTES_SUCCESS = "FETCH_ALL_RETAILER_ATTRIBUTES_SUCCESS";
export const FETCH_ALL_RETAILER_ATTRIBUTES_ERROR = "FETCH_ALL_RETAILER_ATTRIBUTES_ERROR";
export const UPDATE_ALL_RETAILER_ATTRIBUTES = "UPDATE_ALL_RETAILER_ATTRIBUTES";